module.exports = __webpack_public_path__ + "static/images/event/stop.png";